// extracted by mini-css-extract-plugin
export default {"nav":"PageTabs_nav__5A+Up","text":"PageTabs_text__jq3vz","activeTab":"PageTabs_activeTab__fEA87","border":"PageTabs_border__VsvI9"};